import type { ILabelVariantsData } from "@components/atoms/label/types";

export const VLabelVariants: ILabelVariantsData = {
  doctor: { color: "primary-text", background: "gray-background" },
  appointment: { color: "primary-text", background: "gray-background" },
  patient: { color: "primary-text", background: "gray-background" },
};
